<template>
    <div class="news-item" v-if="content" v-on:click.stop="gotoDetail(content.contentId)">
        <div class="news-cover">
            <img v-lazy="content.picture" v-if="content.picture"/>
        </div>
        <div class="news-title">
            <p>{{content.contentTitle}}</p>
        </div>
    </div>

</template>
<script>
export default {
    props:{
        content: {
            type: Object,
            default: () => {},
        },
    },
    methods:{
        gotoDetail(contentId){
            this.$router.push("/mobile/mobileNewsDetail?contentId="+ contentId);
        }
    }
}
</script>

<style scoped>
.news-item{
    display: inline-block;
    width: 49.5%;
    cursor: pointer;
    margin-top: 16px;
}
.news-cover{
    width: 100%;
    overflow: hidden;
    text-align: center;
}
.news-cover img{
    width: 85%;

    overflow: hidden;
}
.news-title, .news-desc{
     width: 85%;
     margin-left: 5%;
     margin-right: 5%;
}
.news-title p{
    font-size: 18px;
    font-weight: bold;
    margin-top: 10px;
    line-height: 28px;
}
.news-desc p{
    font-size: 16px;
    line-height: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/MobileNewsItem50.vue